import React, { useEffect, useLayoutEffect, useState } from "react";
import airconhistoryService from "../services/airconhistory.service";
import ReactPaginate from "react-paginate";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import Loader from "../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import Alertmsg from "../components/Alertmsg";
import clientService from "../services/client.service";
const Airconhistory = (props) => {
  let navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [ismessage, setIsmessage] = useState(false);

  const [airconhistorys, setAirconhistorys] = useState([]);
  const [clients, setClients] = useState([]);
  const [selectedclient, setSelectedclient] = useState([]);

  const [result, setResult] = useState([]);
  //smart table data
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filter, setFilter] = useState("");
  const [filterclient, setFilterclient] = useState("");
  const [filteraircon, setFilteraircon] = useState("unknown aircon");

  const [search, setSearch] = useState("");
  const [between, setBetween] = useState("");
  const [sort, setSort] = useState("");
  const [group, setGroup] = useState("");

  const [pagecount, setPagecount] = useState("");
  const [resultCount, setResultcount] = useState("");

  //table header arrays
  const tableHeaders = [
    { label: "ID", value: "" },
    { label: "aircon id", value: "aircon_id" },
    { label: "Status", value: "ah_status" },
    { label: "Created", value: "createdAt" },
    { label: "actions", value: "" },
  ];
  //filter arrays
  const statusfilterarr = [
    { status_id: "01", status_name: "pending" },
    { status_id: "02", status_name: "active" },
    { status_id: "03", status_name: "inactive" },
  ];
  const [filterarray, setFilterarray] = useState(statusfilterarr);
  //date range
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };

  //use effects
  useEffect(() => {
    if (props.aircon_id!=null) {
      setFilteraircon(props.aircon_id);
      getallAirconhistory();
    } else {
      setFilteraircon("");
    }
    getallClient();
  }, []);
  useLayoutEffect(() => {
    getallAirconhistory();
  }, [page, limit, filter, filterclient, filteraircon, search, between, sort]);

  //get allairconhistory
  const getallAirconhistory = async () => {
    setIsLoaded(true);
    var data = {
      limit: limit,
      page: page,
      filter: filter,
      filterclient: filterclient,
      filteraircon: filteraircon,
      search: search,
      between: between,
      sort: sort,
      group: group,
    };
    return await airconhistoryService
      .getallAirconhistory(data)
      .then((res) => {
        if (res.data.result) {
          setIsLoaded(false);
          setAirconhistorys(res.data.result.data);
          setResult(res.data);
          setPage(res.data.result.page);
          setLimit(res.data.result.limit);
          setPagecount(res.data.result.pagecount);
          setResultcount(res.data.result.resultcount);
          console.log(res.data);
        } else {
          setIsmessage(res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //pagination
  const paginationfn = (event) => {
    setPage(event.selected + 1);
    console.log(event.selected + 1);
  };
  //search
  const searchfn = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };
  //filter
  const [filterArr, setfilterArr] = useState([]);
  const filterfn = (value) => {
    setPage(1);
    var index = filterArr.indexOf(value);
    if (index > -1) {
      filterArr.splice(index, 1);
      setFilter(filterArr.toString());
    } else {
      filterArr.push(value);
      setFilter(filterArr.toString());
    }
  };
  //sort
  const sortfn = (value) => {
    /*    setSort(value); */
    if (sort === value + " desc") {
      setSort(value + " asc");
      console.log(value + " asc");
    } else if (sort === value + " asc") {
      setSort("");
      console.log(value + "");
    } else {
      setSort(value + " desc");
      console.log(value + " desc");
    }
  };
  //between
  /* const [betweenstart, setBetweenstart] = useState("");
  const [betweenend, setBetweenend] = useState("");
  const betweenfn = (value, e) => {
    setPage(1);
    if (e === null || e === "") {
      setBetween("");
      setBetweenstart("");
      setBetweenend("");
    } else {
      if (value === "start") {
        setBetween(e + "," + e);
        console.log(e + "," + e);
        setBetweenstart(e);
        setBetweenend(e);
      } else if (value === "end") {
        setBetweenend(e);
        const dd = between.split(",");
        setBetween(dd[0] + "," + e);
        console.log(dd[0] + "," + e);
        setBetweenstart(dd[0]);
        setBetweenend(e);
      } else {
        setBetween("");
        setBetweenstart("");
        setBetweenend("");
      }
    }
  }; */
  const betweenfn = async (date) => {
    await setStartDate(date.selection.startDate);
    await setEndDate(date.selection.endDate);
    setBetween(
      format(date.selection.startDate, "yyyy-MM-dd") +
        " , " +
        format(date.selection.endDate, "yyyy-MM-dd")
    );
  };
  const resetbetweenfn = () => {
    setBetween("");
    setStartDate(new Date());
    setEndDate(new Date());
  };
  const resetfilterfn = () => {
    setFilter("");
  };
  //get allclient
  const getallClient = async () => {
    var data = {
      limit: 30,
      page: 1,
      filter: "",
      search: "",
      between: "",
      sort: "client_fullname",
      group: "",
    };
    return await clientService
      .getallClient(data)
      .then((res) => {
        if (res.data.result) {
          setClients(res.data.result.data);
          console.log(res.data);
        } else {
        }
      })
      .catch((err) => {});
  };
  const selectedcolor = (value) => {
    if (value === "completed") {
      return "badge rounded-pill bg-success";
    } else if (value === "pending") {
      return "badge rounded-pill bg-warning ";
    } else if (value === "approved") {
      return "badge rounded-pill bg-primary";
    } else {
      return "badge rounded-pill bg-dark";
    }
  };
  // Call airconhistory clicks to request another page.
  if (ismessage == "Network Error") {
    return <Alertmsg alertmsg={ismessage} type={false} />;
  }
  /* if (isLoaded == true) {
    return <Loader />
  } */

  return (
    <div className="">
      <div className="text-center">
        {/*  loader and error handler */}
        {isLoaded ? <Loader /> : <></>}
      </div>
      {/*  container */}
      <div className="airconhistory-container">
        {/* tebale header part search,filter,sort */}
        <div>
          <div className="input-group col-md-6">
            <select
              id="client_id"
              className="form-select"
              aria-label="client_id"
              onChange={(e) => setFilterclient(e.target.value)}
            >
              <option value="" disabled>
                Select Client
              </option>
              <option value="">All</option>
              {clients.map((client, index) => (
                <option
                  className="text-capitalize"
                  key={index}
                  value={client.client_id}
                >
                  {client.client_fullname}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="d-md-flex  mb-2 ">
          {/* create airconhistory */}
          <div className="m-1">
            <button
              onClick={() => {
                navigate("/airconhistoryevent");
              }}
              type="submit"
              className="btn btn-primary  w-100"
            >
              <i className="fa fa-plus-circle"></i> Create
            </button>
          </div>
          {/* filter status*/}
          <div className="dropdown m-1 d-none">
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Filter
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Airconhistory Status</li>
              {filterarray.map((filterdata, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterfn(filterdata.status_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {filterdata.status_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/* search */}
          <div className=" m-1">
            <input
              className="form-control"
              onChange={searchfn}
              placeholder="search"
              type="search"
            ></input>
          </div>
          {/*  date range  */}
          <div className="m-1 ms-auto">
            <div className="btn-group" role="group">
              {between ? (
                <button
                  type="button"
                  className="btn bg-white border me-1 "
                  onClick={resetbetweenfn}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </button>
              ) : (
                <></>
              )}
              <button
                className="btn bg-white border dropdown-toggle"
                id="dropdownMenuClickableInside"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <i className="fa fa-calendar" aria-hidden="true"></i> {between}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuClickableInside"
              >
                <li className="">
                  <DateRangePicker
                    ranges={[selectionRange]}
                    onChange={(date) => betweenfn(date)}
                  />
                </li>
                <li className="text-end">
                  <a onClick={resetbetweenfn} className="btn">
                    Reset
                  </a>
                  {/*  <a data-bs-dismiss="dropdown"  className="btn">Okay</a> */}
                </li>
              </ul>
            </div>
          </div>
          {/* between */}
          {/*  <div className="m-1">
                        <input
                            id="betweenstart"
                            className="form-control"
                            value={betweenstart}
                            onChange={(e) => betweenfn("start", e.target.value ? e.target.value : '')}
                            placeholder="start"
                            type="date"
                        ></input>
                    </div>
                    <div className="m-1">
                        <input
                            id="betweenend"
                            className="form-control"
                            value={betweenend}
                            onChange={(e) => betweenfn("end", e.target.value)}
                            placeholder="start"
                            type="date"
                        ></input>
                    </div> */}
        </div>
        <div>
          {airconhistorys ? (
            <>
              {airconhistorys.map((data, index) => (
                <div className="card shadow-sm border-0 mb-2" key={index}>
                  <div className="card-body">
                    <div className="card-title mb-0 pb-0 d-flex flex-wrap fw-bolder">
                      <div className="flex-fill">{data.ah_type}</div>
                      <div className="me-2">
                        {data.ah_type === "issue" ? (
                          <>${data.total_amount}</>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div>
                        <span className={selectedcolor(data.ah_status)}>
                          {data.ah_status}
                        </span>
                      </div>
                    </div>
                    <div style={{ fontSize: 12 }}>
                      <span
                        className=" text-secondary  text-capitalize"
                        style={{}}
                      >
                        ID:{data.ah_id}/created:{data.createdBy}/date:
                        {data.createdAt}
                      </span>
                    </div>
                    <div className="textwrapmulti">{data.checked_list}</div>

                    <div className="textwrapmulti">
                      {" "}
                      <span style={{ fontWeight: 500 }}>Remarks:</span>
                      {data.ah_remark}
                    </div>
                    {data.ah_type === "issue" &&
                    data.ah_status !== "completed" ? (
                      <div
                        style={{ background: "#FED5C8" }}
                        className="textwrapmulti border p-1"
                      >
                        <span style={{ fontWeight: 500 }}>Recomentation:</span>
                        {data.service_list}
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className="text-end"> <Link
                          className="btn btn-light me-2"
                          to={"/airconhistoryevent?ah_id=" + data.ah_id}
                        >
                          More
                        </Link></div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div>
        <button
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          Launch static backdrop modal
        </button>

        <div
          className="modal"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  Modal title
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">...</div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary">
                  Understood
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Airconhistory;
